var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('v-img',{staticClass:"mt-3",attrs:{"src":_vm.image,"max-height":"80vh","contain":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }